define.alias("ember-cli-clipboard/modifiers/clipboard", "settings/modifiers/clipboard");